import { IconButton, InputAdornment, styled, TextField } from '@mui/material'
import { FC } from 'react'
import { MainComponentFilters } from 'src/generated-types/main-component'
import { Clear } from '@mui/icons-material'

interface TextFilterProps {
  field: string
  placeholder?: string
  type?: 'text' | 'number'
  headerFilters: MainComponentFilters
  filterInputRefs: React.MutableRefObject<Record<string, HTMLInputElement | null>>
  updateFilter: (field: string, value: string) => void
  clearFilter: (field: string) => void
}

const TextFilter: FC<TextFilterProps> = ({ field, placeholder, type = 'text', headerFilters, filterInputRefs, updateFilter, clearFilter }) => {
  return (
    <FilterInput
      size="small"
      type={type}
      placeholder={placeholder}
      defaultValue={headerFilters[field as keyof MainComponentFilters] || ''}
      inputRef={(el) => {
        if (el) filterInputRefs.current[field] = el
      }}
      onChange={(e) => {
        e.stopPropagation()
        updateFilter(field, e.target.value)
      }}
      onClick={(e) => e.stopPropagation()}
      onFocus={(e) => e.stopPropagation()}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              size="small"
              onClick={(e) => {
                e.stopPropagation()
                clearFilter(field)
                if (filterInputRefs.current[field]) {
                  filterInputRefs.current[field]!.value = ''
                }
              }}
              sx={{
                padding: '0px',
                visibility: filterInputRefs.current[field]?.value ? 'visible' : 'hidden'
              }}
            >
              <Clear sx={{ fontSize: '16px' }} />
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  )
}

export const FilterInput = styled(TextField)`
  .MuiInputBase-root {
    font-size: 12px;
    height: 30px;
    background-color: white;
  }
  .MuiInputBase-input {
    padding: 6px 8px;
  }
`

export default TextFilter